export default "__VITE_ASSET__DCBbBoeM__"